/**
 * @Author: Calvin Green <calvin>
 * @Date:   2021-10-22T11:17:54+02:00
 * @Email:  calvin@diversitude.com
 * @Last modified by:   calvin
 * @Last modified time: 2022-08-08T15:50:42+02:00
 * @Copyright: Diversitude 2021
 */



import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
//import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import VueSignaturePad from 'vue-signature-pad';
import * as webix from "../src/webix-pro"
import '../src/webix-pro/webix.css'

import "../src/design/app.scss";

import "../src/design/css/custom.css"


/* Sweetalert toast colors */
import "../src/design/css/sweet-alert.css"

import store from '@/state/store'

import App from './App.vue'

import i18n from './i18n'

//import tinymce from 'vue-tinymce-editor'

import TablePlugin from './plugin/table-plugin/spreadify-plugin.js';
import AnnotatePlugin from './plugin/pdf/pdf-plugin.js'
//import AnnotatePlugin from './plugin/pdf-annotate/annotate-plugin'
//import AnnotatePluginV2 from './plugin/pdf-annotate/annotate-plugin-v2'
import FormPlugin from "./plugin/form-plugin";
/* eslint-disable-next-line */
import OrgChart from './plugin/treant-vue/orgChart'
import { initSpreadifyBackend } from './helpers/spreadify.js'
import uploader from 'vue-simple-uploader'
window.webix = webix;
window.axios = require("axios");
window.axios.defaults.headers.common = {
    'Access-Control-Allow-Origin': '*',
    'X-Requested-With': 'XMLHttpRequest'
};
window.axios.defaults.baseURL = process.env.VUE_APP_API_BASEURL;
/*window.axios.defaults.withCredentials = true;*/
window.axios.interceptors.request.use(function (config) {
  // Do something before request is sent
    let token = localStorage.getItem('x_token');
    if (token) {
        const AUTH_TOKEN = token;
        config.headers.common['Authorization'] = `Bearer ${AUTH_TOKEN}`
    }

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

window.rxmode = (process.env.VUE_APP_TARGET === "rx" ? true : false);

//* Spreadify related plugins
Vue.use(FormPlugin);
Vue.use(TablePlugin);
Vue.use(OrgChart);
Vue.use(AnnotatePlugin);
//Vue.use(AnnotatePluginV2);
Vue.use(VueSignaturePad)

//Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
/*Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})*/
Vue.component('apexchart', VueApexCharts);
Vue.use(uploader);

Vue.prototype.$eventHub = new Vue();
function data_handler(value){
  //eslint-disable-next-line no-undef
  var view = $$(this.webixId);

  if (typeof value === "object"){
    if (this.copyData)
      value = webix.copy(value);

    if (view.setValues)
      view.setValues(value);
    else if (view.parse){
      view.clearAll();
      view.parse(value)
    }
  } else if (view.setValue)
    view.setValue(value);

  var subs = view.queryView(function(sub) {
    return sub.hasEvent && sub.hasEvent("onValue");
  }, "all");

  if (subs.length) {
    for (var i = 0; i < subs.length; i++) {
      subs[i].callEvent("onValue", [value]);
    }
  }
}

Vue.component("webix-ui", {
  props: ['config', 'value', 'copyData'],
  watch:{
    value:{
      handler:data_handler
    }
  },

  template:"<div></div>",

  mounted:function(){
    var config = webix.copy(this.config);
    config.$scope = this;

    this.webixId = webix.ui(config, this.$el);
    if (this.value)
      data_handler.call(this, this.value);
  },
  destroyed:function(){
    webix.$$(this.webixId).destructor();
  }
});

initSpreadifyBackend("19|tgwQ1cBIIunvLLzLAeNPHdSsYsSkEZENEWl03q76");

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
